/* eslint-disable react/no-unescaped-entities */
import { getEmployeeHeadCount,getEmployeeNationalityMix,getEmployeeStatstics } from "api/services/dashboard";
import { useCallback,useEffect,useState } from "react";
import EmployeesByPositionChart from "./charts/EmployeeByPosition";
import EmployeeCostCenter from "./charts/EmployeeCostCenter";
import EmployeeHeadcountChart from "./charts/EmployeeHeadCount";
import EmployeeNationalityMix from "./charts/EmployeeNationalityMix";
import EmployeesByDepartmentChart from "./charts/EmployeesByDepartment";
import EmployeesByGenderChart from "./charts/EmployeesByGender";
import NewEmployeesChart from "./charts/NewEmployeesChart";
import TerminationsChart from "./charts/TerminationsChart";
import TotalEmployeesChart from "./charts/TotalEmployeesChart";

const EmployeeStats = () => {

const [employeeStatstics, setEmployeeStatstics] = useState([])

const [employeeNationalityMix, setEmployeeNationalityMix] = useState([])


const [headCountSeries, setHeadCountSeries] = useState([])
const [headCountCategories, setHeadCountCategories] = useState([])

const [resignedHeadCount, setResignedHeadCount] = useState([])

const getHeadCountSeries = (res) => {
  const series = [
    {
        name: "Current Employees",
        data: res.map(item => item.current_employees)
    },
    {
        name: "New Employees",
        data: res.map(item => item.new_employees)
    },
    {
        name: "Attritions",
        data: res.map(item => item.terminations) 
    }
   
];
  return series
}

const getResignedHeadCountSeries = (res) => {
  const series = [
    {
      name: "Absconding",
      data: res.map(item => item.termination_reasons?.Absconding || 0)
    },
    {
      name: "Contract",
      data: res.map(item => item.termination_reasons?.Contract || 0)
    },
    {
      name: "Resign",
      data: res.map(item => item.termination_reasons?.Resign || 0)
    },
    {
      name: "Terminate",
      data: res.map(item => item.termination_reasons?.Terminate || 0)
    }
  ];
  return series;
}

const getHeadCountCategories = (res) => {
  const categories = res.map(item => new Date(item.month).toLocaleString('en-US', { month: 'short', year: 'numeric' }))
  // res.map(item => item.month)
  return categories
}
const fetchEmployeeHeadCountMemoized = useCallback(() => {
  getEmployeeHeadCount().then(response=>{
    setHeadCountSeries(getHeadCountSeries(response.data))
    setHeadCountCategories(getHeadCountCategories(response.data))
    setResignedHeadCount(getResignedHeadCountSeries(response.data))
  }).catch(()=>{
    // Handle error if needed
  })
}, []);

const fetchEmployeeStatsticsMemoized = useCallback(() => {
  getEmployeeStatstics().then(response=>{
    setEmployeeStatstics(response.data)   
  }).catch(()=>{
    // Handle error if needed
  })
}, []);

const fetchEmployeeNationalityMixMemoized = useCallback(() => {
  getEmployeeNationalityMix().then(response=>{
    setEmployeeNationalityMix(response.data)   
  }).catch(()=>{
    // Handle error if needed
  })
}, []);

const fetchData = useCallback(() => {
 fetchEmployeeHeadCountMemoized();
 fetchEmployeeStatsticsMemoized()
 fetchEmployeeNationalityMixMemoized();
}, [fetchEmployeeHeadCountMemoized, fetchEmployeeStatsticsMemoized, fetchEmployeeNationalityMixMemoized])

useEffect(()=>{
  fetchData()
},[fetchData])
  
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid pb-0">
        
         
        <div className="row">
  {/* Employee Details */}
  <div className="col-lg-12 col-md-12">
    <div className="row g-3">
      <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
        <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", minHeight: "240px", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
          <div className="card-body p-2 d-flex flex-column h-100">           
              {employeeStatstics?.total_employees && 
                <TotalEmployeesChart data={employeeStatstics?.grouped_by_employment_status}
                 activeEmployees={employeeStatstics?.total_active_employees} 
                 terminatedEmployees={employeeStatstics?.total_terminated_employees}
                  totalEmployees={employeeStatstics?.total_employees} 
                  resignedEmployees={employeeStatstics?.total_eos_pending_employees} />
              }
           
          </div>
        </div>
      </div>

      <div className="col-lg-5 col-md-6 col-sm-12 d-flex">
        <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", minHeight: "240px", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
          <div className="card-body p-2 d-flex flex-column h-100">
            <div className="mb-1">
              <h5 className="mb-0" style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>Employee by Department Statistics</h5>
            </div>
            <div className="flex-grow-1">
            {employeeStatstics?.grouped_by_department &&
              <EmployeesByDepartmentChart departments={employeeStatstics?.grouped_by_department} />
            }
          </div>
        </div>
      </div>
                </div>

      <div className="col-lg-3 col-md-6 col-sm-12 d-flex">
        <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", minHeight: "240px", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
          <div className="card-body p-2 d-flex flex-column h-100">
            <div className="mb-1">
              <h5 className="mb-0" style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>Gender Distribution</h5>
            </div>
            <div className="flex-grow-1">
            {employeeStatstics?.grouped_by_gender && 
              <EmployeesByGenderChart genders={employeeStatstics?.grouped_by_gender} />
            }
          </div>
        </div>
      </div>
          </div>
    </div>
  </div>
</div>



    <div className="row mt-3">
          <div className="col-md-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Nationality & Gender Distribution</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-globe" style={{ fontSize: "20px", color: "#fff" }}></i>
                      </div>
                  </div>
                  {employeeNationalityMix && 
                 <EmployeeNationalityMix data={employeeNationalityMix} />
                  }
                  </div>
              </div>
          </div>
          </div>


        


          <div className="row mt-3">
          <div className="col-md-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Employee by Designation</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-user-tie" style={{ fontSize: "20px", color: "#fff" }}></i>
                      </div>
                  </div>
                  {employeeStatstics?.grouped_by_position &&
                 <EmployeesByPositionChart positions={employeeStatstics?.grouped_by_position} />
                  }
                  </div>
              </div>
          </div>
          </div>

          <div className="row mt-3">
          <div className="col-md-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Cost Center Overview</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-building" style={{ fontSize: "20px", color: "#fff" }}></i>
                      </div>
                  </div>
                  {employeeStatstics?.cost_center && 
                <EmployeeCostCenter costCenters={employeeStatstics?.cost_center} />
              }
                  </div>
                  </div> 
                  </div>
          </div>
          

   {/* Employee New Employees, Terminations */}
   <div className="row mt-3">
            <div className="col-md-6 col-sm-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>New Employees</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-user-plus" style={{ fontSize: "20px", color: "#fff" }}></i>
                    </div>
                  </div>
                  <NewEmployeesChart series={headCountSeries} categories={headCountCategories} />
                </div>
              </div>
            </div>

            <div className="col-md-6 col-sm-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Resigned/Terminated/Non-Renewal</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-user-minus" style={{ fontSize: "20px", color: "#fff" }}></i>
                    </div>
                  </div>
                  <TerminationsChart series={resignedHeadCount} categories={headCountCategories} />
                </div>
              </div>
            </div>
          </div>


          {/* Employee Head Count */}
          <div className="row mt-3">
            <div className="col-md-12 d-flex">
              <div className="card shadow-sm w-100" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0" style={{ fontSize: "20px", fontWeight: "600", color: "#333" }}>Employee Head Count</h4>
                    <div style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)"
                    }}>
                      <i className="las la-chart-bar" style={{ fontSize: "20px", color: "#fff" }}></i>
                    </div>
                  </div>
                  <EmployeeHeadcountChart series={headCountSeries} categories={headCountCategories} />
                </div>
              </div>
            </div>
          </div>
    



         
        </div>
        {/* /Page Content */}
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default EmployeeStats;
